import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ProfileInviteButton: React.FC<{ all?: boolean; employeeId?: number }> = ({ all, employeeId }) => {
  const { sessionToken } = useAuth();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const send = async () => {
    if (!window.confirm(all ? 'Send a profile-update email to all active users with an email?' : 'Send this user a profile-update email?')) return;
    try {
      setBusy(true);
      setMessage('');
      const response = await fetch('/api/profile-invite', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Session-Token': sessionToken || '' },
        body: JSON.stringify(all ? { all: true } : { employee_id: employeeId }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Could not send invite');
      const results: { status: string; error?: string }[] = data.results || [];
      setMessage(`Sent: ${results.filter((r) => r.status === 'sent').length}. Skipped: ${results.filter((r) => r.status === 'skipped').length}. Failed: ${results.filter((r) => r.status === 'failed').length}.`);
    } catch (e: any) { setMessage(e.message); }
    finally { setBusy(false); }
  };
  return <div><button className="salary-btn secondary" onClick={send} disabled={busy}>{busy ? 'Sending…' : all ? 'Send profile invite to all' : 'Send profile invite'}</button>{message && <p role="status">{message}</p>}</div>;
};
export default ProfileInviteButton;
